import { type Path, BOOKING } from "@booking/paths";
import { camelize } from "@booking/utils/helpers";
import { EVENT_GROUPS_BY_PATH } from "@booking/utils/tracking";
import { lazy } from "react";
import { RouteObject, Navigate, redirect } from "react-router-dom";

const BookingLayout = lazy(() => import("@booking/app/booking/layout"));
const ErrorElement = lazy(() => import("@booking/app/booking/error"));

const stripBookingPrefix = (path: string) => path.replace(BOOKING.ROOT, "");

const createRoute = (
  path: Path,
  children: RouteObject[] = [],
  overrides: object = {},
): RouteObject => {
  const slug = stripBookingPrefix(path);
  const componentName = camelize(slug);
  const Page = lazy(() => import(`./${componentName}/page.tsx`));

  return {
    children,
    element: <Page eventGroup={EVENT_GROUPS_BY_PATH[path]} />,
    path: slug,
    ...overrides,
  };
};

const routes = {
  path: "/",
  element: <BookingLayout />,
  errorElement: <ErrorElement />,
  children: [
    { element: <Navigate to={BOOKING.PAX} />, index: true },
    createRoute(BOOKING.PAX),
    createRoute(BOOKING.DATE),
    createRoute(BOOKING.ROOMS),
    createRoute(BOOKING.AUTOTIMES),
    createRoute(BOOKING.SIMPLE_TEE_TIMES),
    createRoute(BOOKING.TIMES, [
      { index: true, loader: () => redirect("1") },
      createRoute(BOOKING.TIMES, [], { path: ":roundId" }),
    ]),
    createRoute(BOOKING.DETAILS),
    createRoute(BOOKING.PAYMENT),
    createRoute(BOOKING.COMPLETE),
    createRoute(BOOKING.ENQUIRY),
    createRoute(BOOKING.ENQUIRY_COMPLETE),
  ],
};

export { routes as default };
